/*
 * @Description: 获取代码
 * @Author: gao shuai
 * @Date: 2020-05-20 09:13:09
 * @LastEditTime: 2020-05-23 14:39:43
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 游戏分组下拉
  async gameDraw(params) {
  return api({ url: '/api/SelectDropDown/GetGroupNameNameListAsync', method: 'get', params });
  },
  // 下载获取地址
  async downLink(params) {
  return api({ url: '/api/SelectDropDown/CreateRechargeFileAsync', method: 'get', params });
  },
  // 充值站点
  async chargeStation(params) {
  return api({ url: '/api/SelectDropDown/GetRechargeCircuitAsync', method: 'get', params });
  },
  // 切换登录器开启状态
  async loginSwitch(params) {
  return api({ url: '/api/SelectDropDown/ChangeLoggerStateAsync', method: 'post', data: params });
  },
  // 发布站来源统计
  async publishSwitch(params) {
  return api({ url: '/api/SelectDropDown/ChangeIpsStateAsync', method: 'post', data: params });
  },
  // 获取统计代码
  async staticCode(params) {
  return api({ url: '/api/SelectDropDown/GetLoggerIpsDataAsync', method: 'get', params });
  }
};
